import script from "./PollCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PollCard.vue?vue&type=script&setup=true&lang=js"

import "./PollCard.vue?vue&type=style&index=0&id=6af9f229&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af9f229"]])

export default __exports__